import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../supabaseClient';
import { ToastType } from '../components/Toast';

const STORAGE_KEY = 'skjeta_last_seen_daily_content';

// The daily cron jobs (cron-meme, cron-daily-content) publish fresh
// content every day, but nothing ever told returning visitors it exists -
// they'd only find it by clicking into /memes or /news themselves. This
// surfaces a single "there's new stuff today" toast, once per day, for
// any visitor (logged in or not).
export function useNewContentToast(addToast: (msg: string, type?: ToastType) => void) {
  const { t } = useTranslation('App');

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    let lastSeen: string | null = null;
    try {
      lastSeen = localStorage.getItem(STORAGE_KEY);
    } catch {
      // localStorage unavailable (private mode etc) - just skip the check.
      return;
    }
    if (lastSeen === today) return;

    let cancelled = false;

    supabase
      .from('daily_content')
      .select('date')
      .eq('date', today)
      .eq('type', 'fact')
      .maybeSingle()
      .then(({ data }) => {
        if (cancelled || !data) return;
        addToast(t('newContentToday'), 'info');
        try {
          localStorage.setItem(STORAGE_KEY, today);
        } catch {
          // ignore
        }
      });

    return () => {
      cancelled = true;
    };
  }, [addToast]);
}
